<mat-toolbar
  color="primary"
  fxLayout="row"
  fxLayoutAlign="space-between center"
  role="navigation"
  *ngIf="appConfig.initialized && this.teams"
>
  <button
    mat-icon-button
    *ngIf="isLoggedIn"
    (click)="toggleSidenav()"
    fxHide
    fxShow.lt-md="true"
    aria-label="Show or hide the menu"
  >
    <mat-icon>menu</mat-icon>
  </button>
  <a mat-button fxFlex="nogrow" fxFlex.lt-md [routerLink]="['/home']" [attr.title]="title"
    ><img *ngIf="isEnvironmentStaging" alt="Lineup Staging Home" src="../assets/img/LineupLogoStaging.png" /><img
      *ngIf="!isEnvironmentStaging"
      alt="Lineup Home"
      src="../assets/img/LineupLogo.png"
    />
    <h1>{{ title }}</h1></a
  >
  <workspace-nav *ngIf="isLoggedIn"></workspace-nav>
  <span fxFlex fxShow fxHide.lt-md="true" *ngIf="isLoggedIn"></span>
  <div fxShow fxHide.lt-md="true">
    <a
      mat-button
      class="menu-button"
      *ngIf="this.loggedInSystemUserHasLatestEula"
      [routerLink]="['/home']"
      [attr.title]="'Home'"
    >
      Home
    </a>
    <a
      mat-button
      class="menu-button menu-with-dropdown"
      *ngIf="this.loggedInSystemUserHasLatestEula"
      [routerLink]="['/teams']"
      [attr.title]="'Teams'"
      id="teams-link"
    >
      Teams
    </a>
    <button
      mat-icon-button
      yPosition="before"
      *ngIf="this.loggedInSystemUserHasLatestEula"
      [matMenuTriggerFor]="teamsMenu"
      class="dropdown-arrow"
      aria-label="Teams submenu"
    >
      <mat-icon>arrow_drop_down</mat-icon>
    </button>
    <a
      mat-button
      class="menu-button"
      *ngIf="this.loggedInSystemUserHasLatestEula"
      [routerLink]="['/people']"
      [attr.title]="'People'"
      id="people-link"
    >
      People
    </a>
    <a
      mat-button
      class="menu-button"
      *ngIf="this.loggedInSystemUserHasLatestEula"
      [routerLink]="['/credentialing']"
      [attr.title]="'Credentialing'"
      id="credentialing-link"
      [allowModule]="tenantModuleType.Credentials"
    >
      Credentialing
    </a>
    <a
      mat-button
      class="menu-button"
      *ngIf="this.loggedInSystemUserHasLatestEula"
      [routerLink]="['/reports']"
      [attr.title]="'Reports'"
    >
      Reports
    </a>
    <a
      mat-button
      class="menu-button"
      *ngIf="isAdmin() && this.loggedInSystemUserHasLatestEula"
      [routerLink]="['/admin']"
      [attr.title]="'Admin'"
    >
      Admin
    </a>
    <button mat-button class="menu-button" (click)="openWidget()">Support</button>
    <button
      mat-button
      *ngIf="profile"
      [matMenuTriggerFor]="authMenu"
      class="menu-button profile-button"
      attr.aria-label="{{ profile.given_name }} Account"
      id="profile-button"
    >
      {{ profile.given_name }}
      <mat-icon>arrow_drop_down</mat-icon>
    </button>
  </div>
  <button fxHide fxShow.lt-md="true" fxFlex="nogrow" mat-icon-button *ngIf="isLoggedIn" [matMenuTriggerFor]="menu">
    <mat-icon>account_circle</mat-icon>
  </button>
  <mat-menu #menu>
    <a [routerLink]="['/exports']" mat-menu-item>Exports</a>
    <button *ngIf="canChangePassword | async" (click)="changePassword()" mat-menu-item>Change password</button>
  </mat-menu>
  <mat-menu #teamsMenu>
    <button mat-menu-item [routerLink]="['/teams']" [attr.title]="'Teams'">All Active Teams</button>
    <mat-divider></mat-divider>
    <h3 class="menu-item-header">Recent</h3>
    <button
      mat-menu-item
      *ngFor="let team of activeTeams()"
      [routerLink]="['/teams', team.id]"
      [attr.title]="team?.name"
      routerLinkActive="router-link-active"
    >
      {{ team?.name }}
    </button>
    <mat-divider *ngIf="isManager()"></mat-divider>
    <button *ngIf="isManager()" mat-menu-item class="add-team" (click)="openDialog()" aria-label="Create a new team">
      Create new team
    </button>
  </mat-menu>
  <mat-menu #authMenu>
    <a mat-menu-item href="https://www.lineupteams.com/privacy-policy" target="_blank" [attr.title]="'Privacy Policy'">
      Privacy Policy
    </a>
    <a
      mat-menu-item
      href="https://support.lineupteams.com/hc/en-us/sections/360006008474-Release-Notes"
      target="_blank"
      [attr.title]="'Release Notes'"
    >
      Release Notes
    </a>
    <a
      mat-menu-item
      href="https://support.lineupteams.com/hc/en-us/community/topics"
      target="_blank"
      [attr.title]="'Lineup Community'"
    >
      Lineup Community
    </a>
    <button mat-menu-item *ngIf="this.loggedInSystemUserHasLatestEula" [routerLink]="['/exports']">Exports</button>
    <button
      mat-menu-item
      *ngIf="(canChangePassword | async) && this.loggedInSystemUserHasLatestEula"
      mat-menu-item
      (click)="changePassword()"
    >
      Change password
    </button>
    <button mat-menu-item (click)="logout()" id="logout-button">Log Out</button>
  </mat-menu>
</mat-toolbar>
<mat-progress-bar mode="indeterminate" *ngIf="isLoading" class="app-progress-bar"></mat-progress-bar>
<router-outlet></router-outlet>
